/**
 * Função standalone para copiar texto para área de transferência
 * @param text Texto a ser copiado
 * @returns Promise<boolean> true se copiou com sucesso, false caso contrário
 */
export async function copyToClipboard(text: string): Promise<boolean> {
    try {
        // Verifica se a API Clipboard está disponível
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        } else {
            // Fallback para navegadores mais antigos
            return fallbackCopyToClipboard(text);
        }
    } catch (error) {
        console.error('Erro ao copiar para área de transferência:', error);
        return fallbackCopyToClipboard(text);
    }
}

/**
 * Método fallback para navegadores que não suportam navigator.clipboard
 * @param text Texto a ser copiado
 * @returns boolean true se copiou com sucesso, false caso contrário
 */
function fallbackCopyToClipboard(text: string): boolean {
    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;

        // Evitar scroll e tornar invisível
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        textArea.style.opacity = '0';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        return successful;
    } catch (error) {
        console.error('Erro no fallback de cópia:', error);
        return false;
    }
}
